StatementsManager.HANDLERS.ActionCompleted = StatementHandler.extend({

	initialize: function(params) {
		StatementHandler.prototype.initialize.call(this, params);

		this.skillsManager = this.container.getComponent("SkillsManager");
		this.actionsManager = this.container.getComponent("ActionsManager");
		this.completedActions = [];
	},

	handleBlockInitialized: function(e) {
		StatementHandler.prototype.handleBlockInitialized.call(this, e);

		var block = e.blockData.view;
		if(block instanceof ActionChecklist) {
			this.listenTo(block, "onActionCompleted", this.handleActionCompleted);
		}
	},

	handleActionCompleted: function(e) {
		var action = e.action;
		// ignore previously completed actions for this session
		if(this.completedActions.indexOf(action) !== -1) return;

		var period = action.getLimit();
		var verb = action.getVerb();
		var skillId = action.getSkillId();

		var item = {
			actionId: encodeURI(this.agent.id + action.getId()),
			actionTitle: action.getTitle(),
			period: period != null ? period : "",
			verb: verb != null ? verb : "",
			actionText: action.getNoun(),
			notes: action.getCustom().trim()
		};

		var skill = this.skillsManager.getSkill(skillId);
		if(skill) item.skillTitleURI = encodeURI(skill.getSkillId()); // different to action.skillId
		this.addDataItem(item);

		this.completedActions.push(action);

		this.ready();
	},

	substituteData: function(data) {
        var statement = StatementHandler.prototype.substituteData.call(this, data);

        if(!("skillTitleURI" in data)) delete statement.context.contextActivities; // remove contextActivities if no skill

        return statement;
    },
});
